module.exports = __webpack_public_path__ + "img/choice04.2936616e.png";